export const NUMBER_FORMATTER_TOKEN = Symbol('NUMBER_FORMATTER_TOKEN');

export interface INumberFormatter {
  format(value: number, numDecimals?: number): string;
  formatMoney(value: number, numDecimals?: number): string;
  formatMoneyShort(money: number, numDigits?: number): string;
  formatWinLong(val: number, targetLength: number): string;
  formatJackpotLong(val: number, roundUp?: boolean): string;
  formatValueShortDownBonus(
    jackpotValue: number,
    numDigitsRaw?: number,
    roundUp?: boolean,
    trailingZero?: boolean
  ): string;
  formatLongCoins(val: number, withSpace?: boolean): string;
  formatLongCoins1K(val: number, withSpace?: boolean, numCount?: number): string;
}
